var React = require('react');

function ImgMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 21.3335L29.04 35.3602C29.9164 35.9449 30.9464 36.257 32 36.257C33.0536 36.257 34.0836 35.9449 34.96 35.3602L56 21.3335M13.3333 50.6668H50.6667C52.0812 50.6668 53.4377 50.1049 54.4379 49.1047C55.4381 48.1045 56 46.748 56 45.3335V18.6668C56 17.2523 55.4381 15.8958 54.4379 14.8956C53.4377 13.8954 52.0812 13.3335 50.6667 13.3335H13.3333C11.9188 13.3335 10.5623 13.8954 9.5621 14.8956C8.5619 15.8958 8 17.2523 8 18.6668V45.3335C8 46.748 8.5619 48.1045 9.5621 49.1047C10.5623 50.1049 11.9188 50.6668 13.3333 50.6668Z","stroke":"#223344","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ImgMail.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = ImgMail;

ImgMail.default = ImgMail;
